module.exports = __webpack_public_path__ + "img/filter.2b704668.svg";